import React from "react";
import PropTypes from "prop-types";
import Drawer from "react-md/lib/Drawers";
import Toolbar from "react-md/lib/Toolbars";
import Button from "react-md/lib/Buttons/Button";

const RightDrawer = ({
  getDrawerVisible,
  onToggleDrawer,
  onCloseDrawer,
  children,
  title,
  className
}) => (
  <Drawer
    visible={getDrawerVisible()}
    onVisibilityToggle={onToggleDrawer}
    type={Drawer.DrawerTypes.TEMPORARY}
    position="right"
    header={
      <Toolbar
        nav={<Button icon onClick={onCloseDrawer}>close</Button>}
        className="md-divider-border md-divider-border--bottom"
        title={title}
        colored
      />
    }
    style={{ zIndex: 100 }}
    className={className || null}
  >
    {children}
  </Drawer>
);

RightDrawer.propTypes = {
  getDrawerVisible: PropTypes.func.isRequired,
  onToggleDrawer: PropTypes.func.isRequired,
  onCloseDrawer: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
  className: PropTypes.string
};

RightDrawer.defaultProps = {
  title: "",
  className: null
};

export default RightDrawer;



// WEBPACK FOOTER //
// ./src/staff/components/RightDrawer.jsx